import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';

class DrillDownChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartType: 'bar', // Initial chart type is bar
      chartOptions: {
        chart: {
          id: 'chart-1',
          height: 350,
          chart: {
            events: {
              click: function(event, chartContext, config) {
                this.handleDataPointClick;
                console.log(event);
              }
            }
          }
        },
        plotOptions: {
          bar: {
            columnWidth: '45%',
            distributed: true,
          },
        },
        xaxis: {
          categories: ['Category 1', 'Category 2', 'Category 3', 'Category 4'],
        },
        series: [
          {
            name: 'Data',
            data: [30, 40, 45, 50],
          },
        ],
      },
    };
  }

  handleDataPointClick = (event, chartContext, config) => {
    console.log('Data point clicked:', event, chartContext, config);
    const { chartType } = this.state;
    console.log(data); // Log the clicked data to the console

    // Transition to the next chart type
    let nextChartType;
    if (chartType === 'bar') {
      nextChartType = 'pie';
    } else if (chartType === 'pie') {
      nextChartType = 'line';
    } else {
      nextChartType = 'bar';
    }

    this.setState({
      chartType: nextChartType,
    });
  };

  render() {
    const { chartType, chartOptions } = this.state;

    return (
      <div>
        <ReactApexChart
          options={chartOptions}
          series={chartOptions.series}
          type={chartType}
          height={chartOptions.chart.height}
          events={{
            dataPointClick: this.handleDataPointClick,
          }}
        />
      </div>
    );
  }
}

export default DrillDownChart;
